import { render } from "./Notification.vue?vue&type=template&id=5d84dfee"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"

import "./Notification.vue?vue&type=style&index=0&id=5d84dfee&lang=scss"
script.render = render

export default script